import React from 'react';
import { UserCheck, Building2, Briefcase, GraduationCap, Users } from 'lucide-react';

const audiences = [
  {
    icon: <UserCheck size={24} />,
    title: "Políticos em Mandato",
    desc: "Vereadores, Prefeitos e Parlamentares que buscam reeleição ou expansão de base."
  },
  {
    icon: <Users size={24} />,
    title: "Candidatos e Pretentos",
    desc: "Para quem está construindo uma jornada do zero com base em dados, não em palpites."
  },
  {
    icon: <Building2 size={24} />,
    title: "Gabinetes Legislativos",
    desc: "Equipes técnicas que precisam de relatórios territoriais precisos para gestão."
  },
  {
    icon: <Briefcase size={24} />,
    title: "Consultores Políticos",
    desc: "Profissionais que querem elevar o nível de suas entregas estratégicas."
  }
];

const AudienceSection: React.FC = () => {
  return (
    <section id="audience" className="py-24 px-4 border-t border-zinc-900">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          <div className="lg:w-1/3">
            <h2 className="text-4xl font-bold mb-6">Público <span className="text-[#c17c0c]">Alvo</span></h2>
            <p className="text-zinc-500 leading-relaxed mb-8">
              O Guru.voto foi desenhado para operadores do setor político em posição de gestão administrativa e estratégica. É uma ferramenta de precisão para quem toma decisões de alto impacto.
            </p>
            <div className="p-6 bg-red-500/5 border border-red-500/20 rounded-xl">
              <h4 className="text-red-500 font-bold mb-2 flex items-center">
                <span className="mr-2">⚠️</span> Restrição de Acesso
              </h4>
              <p className="text-xs text-zinc-400">
                Devido à alta demanda computacional (BigQuery/Vertex AI) e à natureza estratégica do serviço, limitamos o número de usuários por região para garantir exclusividade competitiva.
              </p>
            </div>
          </div>
          
          <div className="lg:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {audiences.map((item, i) => (
              <div key={i} className="p-8 bg-zinc-950 border border-zinc-900 rounded-2xl hover:bg-zinc-900 transition-all group">
                <div className="w-12 h-12 rounded-lg bg-[#c17c0c]/10 flex items-center justify-center text-[#c17c0c] mb-6 group-hover:scale-110 transition-transform">
                  {item.icon}
                </div>
                <h3 className="text-lg font-bold mb-2">{item.title}</h3>
                <p className="text-zinc-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AudienceSection;